module.exports = __webpack_public_path__ + "static/media/151-united-arab-emirates.ebda5a3e.svg";